import React from "react";

import "./Loader.scss";
const Loader = () => {
  return <div className="loader">Loading...</div>;
};

export default Loader;
